module.exports = __webpack_public_path__ + "img/atestado_matricula.8a2a2a5e.svg";